import {Autocomplete, Grid, Paper, TextField, useTheme} from "@mui/material";
import React, {useContext, useState} from "react";
import { useTranslation } from "react-i18next";
import {Controller, FormProvider} from "react-hook-form";
import {FormAutocomplete, FormTextField} from "../../common/form-fields-wrappers";
import ActionFilters from "./ActionFiltered";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

const mockCurrentStatus = [
    'CREATED',
    'REJECTED_BY_AUTHORITIES',
    'SUSPENDED_BY_COMMITTEE',
    'ACCEPTED_BY_COMMITTEE',
    'REJECTED_BY_COMMITTEE',
    'NOT_APPROVED',
    'APPROVED',
];
const mockAreaOfApplicationStatus = [
    'VACANT',
    'TAKEN'
];
const mockNewPartner = [
    true,
    false
];
const mockRegionList = [
    "Valle d'Aosta",
    "Piemonte",
    "Lombardia",
    "Friuli Venezia Giulia",
    "Liguria",
    "Trentino Alto Adige",
    "Veneto",
    "Emilia Romagna",
    "Toscana",
    "Marche",
    "Umbria",
    "Lazio",
    "Campania",
    "Basilicata",
    "Molise",
    "Puglia",
    "Calabria",
    "Sicilia",
    "Sardegna",
    "Abbruzzo"

];

const SearchToolFields = ({searchApplicationForm, handleSearch, filterExpandedState}: any) => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();
    const {globalData} = useContext(GlobalContext);
    const legalEntities = globalData.user?.legalEntities;
    const [dealers, setDealers] = useState<any[]>([]);
    const {errors} = searchApplicationForm.formState;

    const [evaluationOutcomeList, setEvaluationOutcomeList] = useState([
        "Committee verification not passed",
        "Committee verification passed but area's taken",
        "Committee verification passed and area's vacant",
        "Underwriting verification not passed",
        "Security verification not passed",
        "Underwriting and security verification not passed",
        "Approved by Underwriting and Security",
        "Partners committee approval",
        "Partners committee rejection"
    ]);

    const handleChangeCurrentStatus = (e: React.SyntheticEvent, value: any) => {
        switch (value) {
            case ("CREATED") :{
                setEvaluationOutcomeList([
                    "Committee verification not passed",
                    "Committee verification passed but area's taken",
                    "Committee verification passed and area's vacant",
                ])
            }
                break;
            case ("ACCEPTED_BY_COMMITTEE") :{
                setEvaluationOutcomeList([
                    "Underwriting verification not passed",
                    "Security verification not passed",
                    "Underwriting and security verification not passed",
                    "Approved by Underwriting and Security",
                ])
            }
                break;
            case ("REJECTED_BY_SECURITY") :{
                setEvaluationOutcomeList([
                    "Partners committee approval",
                    "Partners committee rejection"
                ])
            }
                break;
            case ("SUSPENDED_BY_COMMITTEE") :{
                setEvaluationOutcomeList([
                    "Committee verification not passed",
                    "Committee verification passed and area's vacant",
                ])
            }
                break;
            default :{
                setEvaluationOutcomeList([
                    "Committee verification not passed",
                    "Committee verification passed but area's taken",
                    "Committee verification passed and area's vacant",
                    "Underwriting verification not passed",
                    "Security verification not passed",
                    "Underwriting and security verification not passed",
                    "Approved by Underwriting and Security",
                    "Partners committee approval",
                    "Partners committee rejection"
                ])
            }

        }
    }


    return (
        <Paper elevation={1} sx={{p: theme.spacing(2), mb: theme.spacing(2)}}>
            <FormProvider {...searchApplicationForm}>
                <form onSubmit={searchApplicationForm.handleSubmit(handleSearch)}>
                    <Grid container xs={12} columnSpacing={2}>
                        <Grid item xs={6} md={3}>
                            <FormTextField
                                name="applicationIdentifyingCode"
                                control={searchApplicationForm.control}
                                label={t("searchApplication.form.label.searchFilters.applicationId")}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormAutocomplete
                                name="currentStatus"
                                control={searchApplicationForm.control}
                                label={t("searchApplication.form.label.searchFilters.currentStatus")}
                                fullWidth
                                options={mockCurrentStatus}
                                getOptionLabel={(option) => option ? t(`searchApplication.form.label.currentStatusValue.${option}`) : ''}
                                isOptionEqualToValue={(option, value) => option === value}
                                onChange={handleChangeCurrentStatus}
                            />
                        </Grid>

                        <Grid item xs={6} md={3}>
                            <FormTextField
                                name="companyName"
                                control={searchApplicationForm.control}
                                type={"text"}
                                label={t("searchApplication.form.label.searchFilters.companyName")}
                                fullWidth
                            />
                        </Grid>

                        <ActionFilters
                            searchApplicationForm={searchApplicationForm}
                            handleSearch={handleSearch}
                            filterExpandedState={filterExpandedState}
                        />
                        {filterExpandedState[0] &&
                            <Grid item container xs={12} columnSpacing={2} sx={{mt: theme.spacing(2)}}>
                                <Grid item xs={6} md={3}>
                                    <FormAutocomplete
                                        name="areaOfApplicationStatus"
                                        fullWidth
                                        control={searchApplicationForm.control}
                                        label={t("searchApplication.form.label.searchFilters.areaOfApplicationStatus")}
                                        options={mockAreaOfApplicationStatus}
                                        getOptionLabel={(option) => option ? t(`searchApplication.form.label.areaOfApplicationStatusValue.${option}`) : ''}
                                        isOptionEqualToValue={(option, value) => option === value}
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormAutocomplete
                                        name="newPartner"
                                        control={searchApplicationForm.control}
                                        label={t("searchApplication.form.label.searchFilters.newPartner")}
                                        fullWidth
                                        options={mockNewPartner}
                                        getOptionLabel = {(opt) => opt === true ? t("common.button.yes") : t("common.button.no")}
                                        isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name="vatNumber"
                                        control={searchApplicationForm.control}
                                        type={"text"}
                                        label={t("searchApplication.form.label.searchFilters.vatNumber")}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name="siren"
                                        control={searchApplicationForm.control}
                                        type={"text"}
                                        label={t("searchApplication.form.label.searchFilters.siren")}
                                        fullWidth
                                    />
                                </Grid>

                                {legalEntities.length > 1 &&
                                    <Grid item md={3} xs={12}>
                                        <Controller
                                            control={searchApplicationForm.control}
                                            name="tenants"
                                            render={({field: {onChange, value}}: any) => (
                                                <Autocomplete
                                                    limitTags={1}
                                                    disableCloseOnSelect={true}
                                                    multiple
                                                    id={'tenants'}
                                                    options={legalEntities}
                                                    value={value || []}
                                                    getOptionLabel={(option: any) => t('translation:legalEntities.'.concat(option.name))}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    renderInput={(params) => (
                                                        <TextField {...params}
                                                                    label={t("searchDms.form.label.legalEntities")}
                                                                    error={Boolean(errors?.tenants)}
                                                                    helperText={t(errors?.tenants?.message as string)}
                                                        />
                                                    )}
                                                    onChange={(event, value) => {
                                                        let tmpDealers = globalData.user?.dealers?.filter((dealer: any) => {
                                                            if (value?.length > 0) {
                                                                return value?.find((legalEntity: any) => legalEntity.id === dealer.legalEntities[0].id);
                                                            } else {
                                                                return dealer;
                                                            }
                                                        });
                                                        setDealers(tmpDealers);
                                                        searchApplicationForm.setValue('dealers', []);
                                                        onChange( value);
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                }

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name="name"
                                        control={searchApplicationForm.control}
                                        label={t("searchApplication.form.label.searchFilters.name")}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name="surname"
                                        control={searchApplicationForm.control}
                                        label={t("searchApplication.form.label.searchFilters.surname")}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name="city"
                                        control={searchApplicationForm.control}
                                        label={t("searchApplication.form.label.searchFilters.city")}
                                        fullWidth
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormAutocomplete
                                        name="region"
                                        control={searchApplicationForm.control}
                                        options={mockRegionList}
                                        fullWidth
                                        label={t("searchApplication.form.label.searchFilters.region")}
                                    />
                                </Grid>

                                <Grid item xs={6} md={3}>
                                    <FormTextField
                                        name="postalCode"
                                        control={searchApplicationForm.control}
                                        label={t("searchApplication.form.label.searchFilters.postalCode")}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </form>
            </FormProvider>
        </Paper>

    )
}

export default SearchToolFields;
